import React from "react";
import styles from "./lists.module.scss";
import { Permission } from "@/types/modular-permissions.types";
import type { Config, UseAccountReturnType } from "wagmi";
import MirroredPermissionsCard from "@/features/mod-perms/components/cards/permissions-card/mirrored-permissions-card";

type Props = {
  accountStatus: UseAccountReturnType<Config>;
  permissions: Permission[];
  isLoading: boolean;
};

const MirroredDelegationList = ({
  permissions,
  isLoading,
  accountStatus,
}: Props) => {
  if (permissions.length && !isLoading && accountStatus.isConnected)
    return (
      <div className={styles.mirroredDelegateList}>
        {permissions.map((delegate) => (
          <MirroredPermissionsCard key={delegate._id} delegate={delegate} />
        ))}
      </div>
    );
};

export default MirroredDelegationList;
